// @flow
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import styles from './PromotedBadge.module.scss';

type Props = { className?: string };

const PromotedBadge = (props: Props) => {
    const { className } = props;
    const classes = classNames(styles['promoted-badge'], className);
    return (
        <span className={classes}>
            <FormattedMessage id="featured" />
        </span>
    );
};

export default React.memo<Props>(PromotedBadge);
